/**
 * Return the territories that should recede while a source is waiting for a
 * destination. Keeping this as a pure set decision makes the visual rule easy
 * to test without importing react-native-svg.
 */
export function getSelectionDimmedTerritoryIds(
  allTerritoryIds: readonly string[],
  relevantTerritoryIds: readonly string[],
): string[] {
  if (relevantTerritoryIds.length === 0) return []

  const relevant = new Set(relevantTerritoryIds)
  return allTerritoryIds.filter((id) => !relevant.has(id))
}
